import { useState } from 'react';

export default function DonationBox() {
  const data = window.DOTFW_DATA;

  const [selected, setSelected] = useState(data.currentValue || '');
  const [amountType, setAmountType] = useState(data.amountType);
  const savedCustom = sessionStorage.getItem('dotfw_last_custom');
  const [mode, setMode] = useState(data.mode || 'predefined');
  const [customValue, setCustomValue] = useState(
    data.currentValue !== undefined && data.currentValue !== null
      ? String(data.currentValue)
      : savedCustom || ''
  );
  const [loading, setLoading] = useState(false);
  const isPercentage = data.predefinedAmtType === 'dot_percentage';
  const hasDonation = Number(selected) > 0 || Number(customValue) > 0 || Number(data.currentValue) > 0;

  // AJAX CALL FOR CUSTOM INPUT //
  const sendValue = (value, overrideType) => {
    setLoading(true);
  
    fetch(data.ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'dotfw_set_donation',
        nonce: data.nonce,
        value,
        mode,
        amount_type:
          overrideType === 'percentage_dot_value'
            ? 'percentage_dot_value'
            : 'fixed_dot_value',
      }),
    }).then(() => {
      sessionStorage.setItem('dotfw_last_custom', value);
      window.location.reload();
    });
  };

  // AJAX CALL FOR PREDEFINED INPUT //
  const sendPredefinedValue = (value) => {
    setLoading(true);
  
    fetch(data.ajax_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'dotfw_set_donation',
        nonce: data.nonce,
        value,
      }),
    }).then(() => window.location.reload());
  };

  // REMOVE DONATION //
  const removeDonation = () => {
    sessionStorage.removeItem('dotfw_last_custom');
    sendValue(0);
  };

  const predefinedOptions = data.predefinedValues.map((val) => ({
    label: data.predefinedAmtType === 'dot_percentage'
      ? `${val}%`
      : `${data.currency}${val}`,
    value: val,
  }));

  return (
    <div className="dotfw-card">
      
      <h3 style={{ marginBottom: '15px' }}>{data.mainTitle}</h3>

      {/* PREDEFINED VALUES */}
      {data.selectDonationTypes === 'predefined_value' && data.predefinedFormat === 'dot_radio_btn' && (
        <>
          <div className="dotfw-options">
            {data.predefinedValues.map((val) => {
              return (
                <button
                  type="button"
                  key={val}
                  style={{
                    '--predefined-btn-text-size': data.predefinedValueTextSize + 'px',
                    '--predefined-btn-top-bottom-padding': data.predefinedBtnTopBtmPadding + 'px',
                    '--predefined-btn-left-right-padding': data.predefinedBtnLeftRightPadding + 'px',
                    '--predefined-btn-hover-bg-color': data.predefinedBtnHoverBgColor,
                    '--predefined-btn-hover-text-color': data.predefinedBtnHoverTextColor,
                    '--predefined-btn-active-bg-color': data.predefinedBtnActiveBgColor,
                    '--predefined-btn-active-text-color': data.predefinedBtnActiveTextColor,
                    '--predefined-btn-text-color': data.predefinedBtnTextColor,
                    backgroundColor: data.predefinedBtnBgColor,
                    color: data.predefinedBtnTextColor,
                  }}
                  className={`dotfw-pill ${selected === val && mode === 'predefined' ? 'active' : ''}`}
                  onClick={() => {
                    setMode('predefined');
                    setSelected(val);
                    sendPredefinedValue(val);
                  }}
                >
                  {isPercentage ? `${val}%` : `${data.currency}${val}`}
                </button>
              );
            })}

            {/* OTHER */}
            {data.PredefinedShowOtherBtn === 'yes' && (
              <button
                type="button"
                className={`dotfw-pill ${mode === 'other' ? 'active' : ''}`}
                style={{
                  '--predefined-btn-text-size': data.predefinedValueTextSize + 'px',
                  '--predefined-btn-top-bottom-padding': data.predefinedBtnTopBtmPadding + 'px',
                  '--predefined-btn-left-right-padding': data.predefinedBtnLeftRightPadding + 'px',
                  '--predefined-btn-hover-bg-color': data.predefinedBtnHoverBgColor,
                  '--predefined-btn-hover-text-color': data.predefinedBtnHoverTextColor,
                  '--predefined-btn-active-bg-color': data.predefinedBtnActiveBgColor,
                  '--predefined-btn-text-color': data.predefinedBtnTextColor,
                  backgroundColor: data.predefinedBtnBgColor,
                  color: data.predefinedBtnTextColor,
                }}
                onClick={() => setMode('other')}
                disabled={loading}
              >
                {data.otherText}
              </button>
            )}
            
            {/* CUSTOM INPUT */}
            {mode === 'other' && (
              <div className="dotfw-custom">
                <div className="dotfw-input-wrap">
                  <input
                    type="number"
                    value={customValue}
                    placeholder="Enter amount"
                    disabled={loading}
                    onChange={(e) => {
                      setCustomValue(e.target.value);
                      sessionStorage.setItem('dotfw_last_custom', e.target.value);
                    }}
                  />
                </div>
                <span style={{ fontSize: data.predefinedValueTextSize + 'px' }}>
                  {isPercentage ? '%' : data.currency}
                </span>

                <button
                  type="button"
                  className="dotfw-primary-btn"
                  style={{ 
                    fontSize: data.donationBtnSize + 'px', 
                    color: data.donationBtnTextColor, 
                    backgroundColor: data.donationBtnBgColor 
                  }}
                  onClick={() => {
                    setMode('other');
                    setSelected(customValue);
                    sendValue(customValue, data.predefinedAmtType);
                  }}
                  disabled={!customValue || loading}
                >
                  {loading ? 'Applying…' : data.buttonText}
                </button>
              </div>
            )}

            {/* REMOVE */}
            {data.DisplayRemoveDonationBtn === 'yes' && (
              <div className="dotfw-actions">
                <button
                  type="button"
                  className="dotfw-link-btn"
                  style={{ 
                    fontSize: data.removeDonationBtnTextSize + 'px', 
                    backgroundColor: data.removeDonationBtnBgColor,
                    color: data.removeDonationBtnTextColor,
                  }}
                  onClick={removeDonation}
                  disabled={loading}
                >
                  {data.removeText}
                </button>
              </div>
            )}
          </div>
        </>
      )} 
      
      {data.selectDonationTypes === 'predefined_value' && data.predefinedFormat === 'dot_dropdown' && (
        <div className="dotfw-options">
          <div className="dotfw-custom">
            <select
              style={{ width: '150px', height: 'auto', '--select-font-size': data.predefinedValueTextSize + 'px' }}
              value={selected}
              // options = {predefinedOptions}
              onChange={(e) => {
                setMode('predefined');
                setSelected(e.target.value);
              }}
            >
              {predefinedOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>

            {/* ADD BUTTON */}
            <button
              type="button"
              className="dotfw-primary-btn"
              style={{ 
                fontSize: data.donationBtnSize + 'px', 
                color: data.donationBtnTextColor, 
                backgroundColor: data.donationBtnBgColor 
              }}
              onClick={() => {
                sendPredefinedValue(selected);
              }}
              disabled={loading}
            >
              {loading ? 'Applying…' : data.buttonText}
            </button>
          </div>

          {/* REMOVE */}
          {data.DisplayRemoveDonationBtn === 'yes' && (
            <button
              type="button"
              className="dotfw-link-btn"
              style={{ 
                fontSize: data.removeDonationBtnTextSize + 'px', 
                backgroundColor: data.removeDonationBtnBgColor,
                color: data.removeDonationBtnTextColor,
              }}
              onClick={removeDonation}
              disabled={loading}
            >
              {data.removeText}
            </button>
          )}
        </div>
      )}

      {/* TEXT VALUE MODE */}
      {data.selectDonationTypes === 'donation_text_value' && (
        <div className="dotfw-options">
          <div className="dotfw-custom">
            {/* FIXED / PERCENTAGE SELECT */}
            <select
              className="dotfw-select"
              value={amountType}
              onChange={(e) => setAmountType(e.target.value)}
              disabled={loading}
            >
              <option value="fixed_dot_value">Fixed</option>
              <option value="percentage_dot_value">Percentage</option>
            </select>

            {/* AMOUNT INPUT */}
            <div className="dotfw-input-wrap">
              <input
                type="number"
                value={customValue}
                placeholder="Enter amount"
                disabled={loading}
                onChange={(e) => setCustomValue(e.target.value)}
              />
            </div>
            <span style={{ fontSize: '16px' }}>
              {amountType === 'percentage_dot_value' ? '%' : data.currency}
            </span>

            {/* ADD BUTTON */}
            <button
              type="button"
              className="dotfw-primary-btn"
              style={{ 
                fontSize: data.donationBtnSize + 'px', 
                color: data.donationBtnTextColor, 
                backgroundColor: data.donationBtnBgColor 
              }}
              onClick={() => {
                if (!customValue) return;
                setSelected(customValue);
                sendValue(customValue, amountType);
              }}
              disabled={!customValue || loading}
            >
              {loading ? 'Applying…' : data.buttonText}
            </button>
          </div>

          {/* REMOVE */}
          {data.DisplayRemoveDonationBtn === 'yes' && (
            <button
              type="button"
              className="dotfw-link-btn"
              style={{ 
                fontSize: data.removeDonationBtnTextSize + 'px', 
                backgroundColor: data.removeDonationBtnBgColor,
                color: data.removeDonationBtnTextColor,
              }}
              onClick={removeDonation}
              disabled={loading}
            >
              {data.removeText}
            </button>
          )}
        </div>
      )}

      {data.altText && hasDonation && (
        <p 
          className="dotfw-helper-text" 
          style={{
            color: data.alertTextColor,
            fontSize: data.alertFontSize + 'px',
          }}
        >
          {data.altText}
        </p>
      )}
    </div>
  );
}